import React, { useEffect, useRef, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "./Navbar.css";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);
  const closeServices = () => setServicesOpen(false);

  const baseNavItems = [
    { label: "Home", to: "/" },
    { label: "Gallery", to: "/gallery" },
    { label: "Blog", to: "/blog" },
    { label: "About", to: "/about" },
  ];

  const serviceLinks = [
    { label: "Residential Painting", to: "/residential-painting" },
    { label: "Commercial Painting", to: "/commercial-painting" },
    { label: "Interior Painting", to: "/interior-painting" },
    { label: "Exterior Painting", to: "/exterior-painting" },
    { label: "Fast Flash Rentals", to: "/rental-painting-fast-flash" },
    { label: "Airbnb Painting", to: "/airbnb-painting" },
    { label: "House Painters", to: "/house-painters" },
    { label: "Interior Decals", to: "/interior-decals" },
    { label: "Fast Flash", to: "/fast-flash" },
  ];

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setServicesOpen(false);
      }
    };
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        setServicesOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEsc);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEsc);
    };
  }, []);

  const toggleServices = () => setServicesOpen((prev) => !prev);

  return (
    <nav className={`navbar${isOpen ? " menu-open" : ""}`}>
      <div className="navbar-container">
        <Link
          to="/"
          className="company-logo"
          onClick={() => {
            closeMenu();
            closeServices();
          }}
        >
          J3 Innovations
        </Link>
        <div className="menu-icon" onClick={toggleMenu}>
          <i className={isOpen ? "fas fa-times" : "fas fa-bars"} />
        </div>
        <ul className={isOpen ? "nav-menu active" : "nav-menu"}>
          <div className="nav-desktop">
            {baseNavItems.map((item) => (
              <li className="nav-item" key={item.to}>
                <NavLink
                  to={item.to}
                  className={({ isActive }) => `nav-link${isActive ? " active" : ""}`}
                  onClick={() => {
                    closeMenu();
                    closeServices();
                  }}
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
            <li className="nav-item dropdown" ref={dropdownRef}>
              <button
                className="nav-link dropdown-trigger"
                aria-haspopup="true"
                aria-expanded={servicesOpen}
                onClick={toggleServices}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    toggleServices();
                  }
                }}
              >
                Services <span className="caret">▾</span>
              </button>
              {servicesOpen && (
                <div className="dropdown-panel">
                  <div className="dropdown-grid">
                    {serviceLinks.map((item) => (
                      <NavLink
                        key={item.to}
                        to={item.to}
                        className={({ isActive }) => `dropdown-link${isActive ? " active" : ""}`}
                        onClick={() => {
                          closeMenu();
                          closeServices();
                        }}
                      >
                        {item.label}
                      </NavLink>
                    ))}
                  </div>
                </div>
              )}
            </li>
            <li className="nav-item cta-item">
              <NavLink
                to="/quote"
                className="nav-link nav-cta"
                onClick={() => {
                  closeMenu();
                  closeServices();
                }}
              >
                Request a Free Estimate
              </NavLink>
            </li>
          </div>

          <div className="nav-mobile">
            {[...baseNavItems, ...serviceLinks].map((item) => (
              <li className="nav-item" key={`m-${item.to}`}>
                <NavLink
                  to={item.to}
                  className={({ isActive }) => `nav-link${isActive ? " active" : ""}`}
                  onClick={() => {
                    closeMenu();
                    closeServices();
                  }}
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
            <li className="nav-item">
              <NavLink
                to="/quote"
                className="nav-link nav-cta"
                onClick={() => {
                  closeMenu();
                  closeServices();
                }}
              >
                Request a Free Estimate
              </NavLink>
            </li>
          </div>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
